import React from 'react';

import { createIcon } from '@chakra-ui/react';

export const AvatarIcon = createIcon({
  displayName: 'AvatarIcon',
  viewBox: '0 0 20 20',
  path: (
    <>
      <g clipPath="url(#clip0_901_26661)">
        <path
          clipRule="evenodd"
          d="M9.99967 2.50016C5.85754 2.50016 2.49967 5.85803 2.49967 10.0002C2.49967 11.4851 2.93122 12.8692 3.67574 14.034C3.93156 13.8306 4.25393 13.6039 4.64741 13.379C5.80504 12.7174 7.55707 12.0835 10.0001 12.0835C12.4431 12.0835 14.1952 12.7174 15.3528 13.379C15.746 13.6038 16.0682 13.8303 16.3239 14.0336C17.0682 12.8689 17.4997 11.4849 17.4997 10.0002C17.4997 5.85803 14.1418 2.50016 9.99967 2.50016ZM15.2764 15.33C15.0838 15.1777 14.8349 15.0027 14.5258 14.826C13.6088 14.302 12.1404 13.7502 10.0001 13.7502C7.8598 13.7502 6.3914 14.302 5.47443 14.826C5.16506 15.0029 4.916 15.178 4.72337 15.3303C6.07842 16.6718 7.94231 17.5002 9.99967 17.5002C12.0572 17.5002 13.9213 16.6716 15.2764 15.33ZM17.1038 15.7936C18.3931 14.2145 19.1663 12.1977 19.1663 10.0002C19.1663 4.93755 15.0623 0.833496 9.99967 0.833496C4.93706 0.833496 0.833008 4.93755 0.833008 10.0002C0.833008 15.0628 4.93706 19.1668 9.99967 19.1668C12.8434 19.1668 15.3848 17.8719 17.0661 15.8395C17.0793 15.8246 17.0919 15.8093 17.1038 15.7936ZM9.99967 5.8335C9.0792 5.8335 8.33301 6.57969 8.33301 7.50016C8.33301 8.42064 9.0792 9.16683 9.99967 9.16683C10.9201 9.16683 11.6663 8.42064 11.6663 7.50016C11.6663 6.57969 10.9201 5.8335 9.99967 5.8335ZM6.66634 7.50016C6.66634 5.65921 8.15872 4.16683 9.99967 4.16683C11.8406 4.16683 13.333 5.65921 13.333 7.50016C13.333 9.34111 11.8406 10.8335 9.99967 10.8335C8.15872 10.8335 6.66634 9.34111 6.66634 7.50016Z"
          fill="black"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_901_26661">
          <rect fill="white" height="20" width="20" />
        </clipPath>
      </defs>
    </>
  ),
});
